.trigger {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 192px;
  height: 42px;
  padding: 10px;
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  border: 2px solid var(--color-border-normal);
  border-radius: 4px;

  &[data-placeholder] {
    color: var(--color-text-placeholder);
  }

  &:focus-visible {
    outline: none;
    border: 2px solid var(--color-secondary-blue-600);
  }

  span:first-of-type {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
  }
}

.content {
  z-index: var(--z-index-high);
  width: 100%;
  padding: 13px 0;
  margin-top: 4px;
  background: var(--color-white);
  border: none;
  border-radius: 2px;
  box-shadow: var(--box-shadow-base);
  transform: translateX(22px);

  &:focus-within {
    outline: none;
    box-shadow: var(--box-shadow-base);
  }
}

.item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 34px;
  font-size: var(--font-size-sm);
  line-height: 2;
  color: var(--color-text-primary);
  cursor: pointer;
  background: var(--color-white);
  opacity: 1;
  transition: background-color 0.2s ease;

  &[data-highlighted] {
    outline: none;
    background-color: var(--color-gray-100);
  }
}

.itemIndicator {
  position: absolute;
  left: 13px;
  display: inline-flex;
  margin-right: 8px;
}

.error {
  border: 2px solid var(--color-error-border);

  &:focus-within {
    border: 2px solid var(--color-error-border);
  }
}

.scrollChevron {
  display: flex;
  align-items: center;
  justify-content: center;
}
